import Vue from "vue"
//import axios from 'axios';

function makeNotification(type, data) {
    if (typeof data === "string" || data instanceof String) {
        return { type, text: data }
    } else {
        return { type, ...data }
    }
}

export default {
    state: {
        notifications: [],
    },

    getters: {
        notifications: (state) => {
            return state.notifications
        },
    },

    mutations: {
        // Each of the below four takes either a string or an object with 'text' and optional 'timeout' keys, where 'timeout' is in milliseconds or 'none'
        successNotify(state, data) {
            state.notifications.push(makeNotification("success", data))
        },

        infoNotify(state, data) {
            state.notifications.push(makeNotification("info", data))
        },

        warningNotify(state, data) {
            state.notifications.push(makeNotification("warning", data))
        },

        dangerNotify(state, data) {
            state.notifications.push(makeNotification("danger", data))
        },

        dismissNotification(state, notification) {
            console.log("dismissing notification: " + notification)
            state.notifications.splice(notification, 1)
        },
    },

    actions: {},
}
